module.exports = __webpack_public_path__ + "static/media/GOTV.0fa007aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/GOTV.svg
// module id = 384
// module chunks = 25